import React from "react";
import classes from './IndustrialDesignDocumet.module.scss'
import Document from "../../../../components/Document";
export default function IndustrialDesignDocumet() {
    return(
        <Document/>

    )
    
}